import React from 'react';
import {AuthConsumer} from '../../../providers/AuthProvider';

import '../../../index.scss';
import NewPageLoader from '../../page-loader/NewPageLoader';

export const Callback = () => (
  <AuthConsumer>
    {({signinRedirectCallback}) => {
      signinRedirectCallback();
      return (
        <div className="loading-page-container">
          <NewPageLoader />
        </div>
      );
    }}
  </AuthConsumer>
);
